import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

/**
 * roles – optional array of allowed roles, e.g. ['admin', 'trainer']
 * If omitted, any authenticated user is allowed.
 */
export default function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/workouts" replace />;
  }
  return <React.Fragment key={user.id}>{children}</React.Fragment>;
}
